import { useEffect } from "react";
import { useSearch } from "@tanstack/react-router";
import { PageHeader } from "../../../components/ui";
import { askWhy } from "../askwhy/store";
import { AskWhyDrawer } from "../askwhy/AskWhyDrawer";

/** The conversation is the page. A pullout is only for asking from a session or an issue. */
export function AskWhyPage() {
  const search = useSearch({ strict: false }) as { session?: string; cluster?: string; conversation?: string };
  useEffect(() => {
    askWhy.open({ sessionId: search.session, clusterId: search.cluster });
    if (search.conversation) void askWhy.load(search.conversation).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="askwhy-screen">
      <PageHeader title="Ask Why" />
      <AskWhyDrawer variant="page" />
    </div>
  );
}
